
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autocert",
      function () {
        return require("private-next-pages/autocert.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autocert"])
      });
    }
  